import type {ReactElement} from 'react';
import React from 'react';
import {BaseTextOutlineOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-text-outline-option';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {TranscriptSentenceOutlineOptionProps} from './transcript-sentence-outline-option.types';
import {useGetKeyFromSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleTextStylesForTranscriptItem';

export function TranscriptSentenceOutlineOption({...props}: TranscriptSentenceOutlineOptionProps): ReactElement {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptSentenceOutlineOption');
  }

  const stroke = useGetKeyFromSubtitleTextStylesForTranscriptItem('stroke', false);
  if (stroke === undefined) {
    throw new Error('Transcript item does not have stroke in sentenceTextStyles');
  }

  const strokeWidth = useGetKeyFromSubtitleTextStylesForTranscriptItem('strokeWidth', false);
  if (strokeWidth === undefined) {
    throw new Error('Transcript item does not have strokeWidth in sentenceTextStyles');
  }

  const strokeColor = useGetKeyFromSubtitleTextStylesForTranscriptItem('strokeColor', false);
  if (strokeColor === undefined) {
    throw new Error('Transcript item does not have strokeColor in sentenceTextStyles');
  }

  const onClickColorFill = (): void => {
    props.onSentenceStrokeColorFillClick();
  };

  const onToggleOutlineOption = async (): Promise<void> => {
    await activeItem.updateAllSubtitlesStylesFromSubtitleObject({
      sentenceTextStyles: {
        stroke: !activeItem.getAnySubtitle().sentenceTextStyles.stroke,
      },
    });
  };

  const updateStrokeThickness = async (strokeWidth: number, undoable = true): Promise<void> => {
    await activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        sentenceTextStyles: {
          strokeWidth,
        },
      },
      {undoable}
    );
  };

  return (
    <BaseTextOutlineOption
      showNewTag={false}
      stroke={stroke}
      isDisabled={false}
      strokeWidth={strokeWidth}
      strokeColor={strokeColor}
      onToggleOutlineOption={onToggleOutlineOption}
      updateStrokeThickness={updateStrokeThickness}
      onClickColorFill={onClickColorFill}
    />
  );
}
